export default __webpack_public_path__ + "static/media/Mark-6-Suit-04.9d81000b.jpg";